<app-header [forceLightBackground]="true"></app-header>
<div class="admin-view-all-users">
  <div class="admin-view-all-users--layout">
    <app-admin-sidebar class="admin-view-all-users--sidebar"></app-admin-sidebar>
    <div class="admin-view-all-users--content">
      <app-page-header></app-page-header>
      <div class="view-all-users-container">
        
        <!-- Filter Section -->
        <app-filter-panel
          [fields]="filterFields"
          [defaultExpanded]="false"
          (filterChange)="onFilterChange($event)"
          (clearFilters)="onClearFilters()"
        ></app-filter-panel>

        <!-- Table -->
        <app-table
          [columns]="columns"
          [data]="usersData"
          [scrollHeight]="'400px'"
          [loading]="loading"
          [pagination]="pagination"
          [emptyMessage]="emptyMessage"
          [striped]="true"
          [bordered]="true"
          [hoverable]="true"
          (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)"
        >
          <!-- User Added On: format from raw API timestamp (IST), same as details modal -->
          <ng-template #userAddedOnCell let-row>
            <ng-container *ngIf="row.userAddedOnRaw; else noUserAddedOn">
              <span class="table--date-cell">
                <span class="table--date-part">{{ formatService.formatDateOnly(row.userAddedOnRaw) }}</span>
                <span class="table--time-part">{{ formatService.formatTimeOnly(row.userAddedOnRaw) }}</span>
              </span>
            </ng-container>
            <ng-template #noUserAddedOn>—</ng-template>
          </ng-template>

          <!-- Custom Status Column -->
          <ng-template #statusCell let-row>
            <div class="status-cell">
              <span 
                class="status-indicator" 
                [class.status-active]="row.accountStatus?.toLowerCase() === 'active'"
                [class.status-inactive]="row.accountStatus?.toLowerCase() === 'inactive'"
              ></span>
              <span>{{ row.accountStatus }}</span>
            </div>
          </ng-template>

          <!-- Custom Action Column (dropdown is rendered in fixed overlay below) -->
          <ng-template #actionCell let-row>
            <div class="action-cell-wrapper">
              <button 
                class="action-btn" 
                appActionDropdownTrigger
                (click)="toggleActionDropdown($event, row)"
                [class.active]="isDropdownOpen(row)"
              >
                <span>Action</span>
              </button>
            </div>
          </ng-template>
        </app-table>
        
      </div>
    </div>
  </div>
</div>

<!-- Fixed overlay: dropdown on top of table -->
<div
  *ngIf="dropdownPosition && openDropdownRow"
  class="action-dropdown-overlay action-dropdown-overlay--align-end"
  [style.top.px]="dropdownPosition.top"
  [style.left.px]="dropdownPosition.left"
  [style.right.px]="dropdownPosition.right"
  (click)="$event.stopPropagation()"
>
  <ul class="dropdown-list">
    <li class="dropdown-item">
      <button type="button" class="dropdown-link" (click)="handleAction('view', openDropdownRow)">
        Details
      </button>
    </li>
    <li class="dropdown-item">
      <button 
        type="button"
        class="dropdown-link" 
        (click)="handleAction(openDropdownRow.accountStatus === 'Active' ? 'deactivate' : 'activate', openDropdownRow)">
        {{ openDropdownRow.accountStatus === 'Active' ? 'Deactivate' : 'Activate' }}
      </button>
    </li>
  </ul>
</div>

<!-- User Details Modal -->
<app-tab-modal
  [(visible)]="isModalVisible"
  header="Additional Information"
  [width]="'600px'"
  [height]="'520px'"
  [tabs]="modalTabs"
  defaultTab="user"
  (onClose)="closeModal()"
></app-tab-modal>

<!-- User Tab Content Template -->
<ng-template #userTabContent>
  <div class="user-details-section" *ngIf="selectedUser">
    <div *ngIf="userDetailsLoading" class="no-data-message">
      Loading user details…
    </div>
    <div *ngIf="!userDetailsLoading && !userDetails" class="no-data-message">
      No Data Available
    </div>
    <div *ngIf="!userDetailsLoading && userDetails">
      <div class="detail-row">
        <div class="detail-label">Name:</div>
        <div class="detail-value">{{ userDetails.name || 'N/A' }}</div>
      </div>
      <div class="detail-row">
        <div class="detail-label">Email:</div>
        <div class="detail-value">{{ userDetails.email || 'N/A' }}</div>
      </div>
      <div class="detail-row">
        <div class="detail-label">Current Role:</div>
        <div class="detail-value">
          <ng-container *ngIf="getDetailsCurrentRoleDisplay() as currentRole; else noCurrentRole">
            <span class="roles-container">
              <span class="role-badge">{{ currentRole }}</span>
            </span>
          </ng-container>
          <ng-template #noCurrentRole>N/A</ng-template>
        </div>
      </div>
      <div class="detail-row">
        <div class="detail-label">Email Verified:</div>
        <div class="detail-value">{{ userDetails.emailVerified ? 'Yes' : 'No' }}</div>
      </div>
      <div class="detail-row">
        <div class="detail-label">Account Status:</div>
        <div class="detail-value">
          <div class="status-cell">
            <span
              class="status-indicator"
              [class.status-active]="userDetails.account_enabled"
              [class.status-inactive]="!userDetails.account_enabled"
            ></span>
            <span>{{ userDetails.account_enabled ? 'Active' : 'Inactive' }}</span>
          </div>
        </div>
      </div>
      <div class="detail-row">
        <div class="detail-label">Created At:</div>
        <div class="detail-value" *ngIf="userDetails.createdAt || userDetails.created_at">
          <span class="date-part">{{ formatService.formatDateOnly(userDetails.createdAt || userDetails.created_at) }}</span>
          <span class="time-part">{{ formatService.formatTimeOnly(userDetails.createdAt || userDetails.created_at) }}</span>
        </div>
        <div class="detail-value" *ngIf="!userDetails.createdAt && !userDetails.created_at">N/A</div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Organisation Tab Content Template -->
<ng-template #organisationTabContent>
  <div class="organisation-details-section" *ngIf="selectedUser">
    <div *ngIf="userDetailsLoading" class="no-data-message">
      Loading organisation details…
    </div>
    <div *ngIf="!userDetailsLoading && organisationDetails">
      <div class="detail-row">
        <div class="detail-label">Organisation Name:</div>
        <div class="detail-value">{{ organisationDetails.name || 'N/A' }}</div>
      </div>
      <div class="detail-row">
        <div class="detail-label">Employee ID:</div>
        <div class="detail-value">{{ organisationDetails.empId || 'N/A' }}</div>
      </div>
      <div class="detail-row">
        <div class="detail-label">Job Title:</div>
        <div class="detail-value">{{ organisationDetails.jobTitle || 'N/A' }}</div>
      </div>
      <div class="detail-row" *ngIf="hasOrganisationFieldValue(organisationDetails.entityType)">
        <div class="detail-label">Entity Type:</div>
        <div class="detail-value">{{ organisationDetails.entityType }}</div>
      </div>
      <div class="detail-row" *ngIf="hasOrganisationFieldValue(organisationDetails.address)">
        <div class="detail-label">Address:</div>
        <div class="detail-value">{{ organisationDetails.address }}</div>
      </div>
      <div class="detail-row" *ngIf="hasOrganisationFieldValue(organisationDetails.joinedAtRaw)">
        <div class="detail-label">Joined At:</div>
        <div class="detail-value">
          <span class="date-part">{{ formatService.formatDateOnly(organisationDetails.joinedAtRaw) }}</span>
          <span class="time-part">{{ formatService.formatTimeOnly(organisationDetails.joinedAtRaw) }}</span>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Confirmation Dialog for Activate/Deactivate -->
<app-confirmation-dialog
  [(visible)]="isConfirmationVisible"
  [type]="isActivating ? 'success' : 'warning'"
  [title]="isActivating ? 'Activate User' : 'Deactivate User'"
  [message]="userToDeactivate ? 'Are you sure you want to ' + (isActivating ? 'activate' : 'deactivate') + ' ' + (userToDeactivate.userName || 'this user') + '? This action cannot be undone.' : 'Are you sure you want to ' + (isActivating ? 'activate' : 'deactivate') + ' this user? This action cannot be undone.'"
  [confirmLabel]="isActivating ? 'Activate' : 'Deactivate'"
  cancelLabel="Cancel"
  [themeColor]="isActivating ? 'green' : 'red'"
  (onConfirm)="onDeactivateConfirm()"
  (onCancel)="onDeactivateCancel()"
  (onClose)="onDeactivateCancel()"
></app-confirmation-dialog>